import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import AnaliseOperacionalModal from '../../../../../components/AnaliseOperacionalModal/AnaliseOperacionalModal';
import { Col } from '../../../../../components/Col';
import CardTitle from '../../../../../components/CrudWithSteps/components/CardTitle';
import GenericContent from '../../../../../components/CrudWithSteps/components/GenericContent';
import { CustomButton } from '../../../../../components/CustomButton';
import GenericCardScreen from '../../../../../components/GenericCardScreen/GenericCardScreen';
import HistoricoAnaliseOperacionalModal from '../../../../../components/HistoricoAnaliseOperacionalModal/HistoricoAnaliseOperacionalModal';
import AssignmentLateRoundedIcon from '../../../../../components/Icons/AssignmentLateRoundedIcon';
import CloudDownloadIcon from '../../../../../components/Icons/CloudDownloadIcon';
import DoneIcon from '../../../../../components/Icons/DoneIcon';
import HistoryRoundedIcon from '../../../../../components/Icons/HistoryRoundedIcon';
import ProgressModal from '../../../../../components/ProgressModal/ProgressModal';
import { Row } from '../../../../../components/Row';
import { CONTRATO_EDIT_ETAPA_ARQUIVOS } from '../../../../../library/ContratoEditEtapas';
import { CONTRATO_STATUS_EM_EDICAO } from '../../../../../library/ContratoStatus';
import {
  CONTRATO_VERSAO_ADITIVO,
  CONTRATO_VERSAO_ADITIVO_NAME,
  CONTRATO_VERSAO_CONTRATO,
  CONTRATO_VERSAO_CONTRATO_NAME,
  CONTRATO_VERSAO_DISTRATO,
  CONTRATO_VERSAO_DISTRATO_NAME,
} from '../../../../../library/ContratoVersoes';
import { contratoEditRoute } from '../../../../../library/Routes';
import { downloadValidacaoContrato } from '../../../../../store/modules/ContratosEntePrivadoActions';
import {
  /* loadHistoricoContratoEntePrivadoAnaliseOperacional ,*/ contratoEntePrivadoSendAnaliseOperacional,
  gerarContratoNaoAssinado,
} from '../../../../../store/modules/ContratosEntePrivadoActions';
import {
  changeModalProps,
  closeModal,
  openModal,
} from '../../../../../store/modules/ModalActions';
import genericCardStyles from './../../../../../components/GenericCard/GenericCard.scss';
import styles from './Validacao.scss';
import { getContratoTipoByRouteParams } from '../../../../../utils/ContratoUtils';
import SnackbarUtils from 'utils/SnackbarUtils';

const rootClassName = styles.rootClassName;

const INITIAL_STATE = {
  sending: false,
  downloadValidacaoModalKey: null,
  analiseOperacionalModalKey: null,
};

class Validacao extends GenericContent {
  constructor(props) {
    super(props);
    this.state = {
      ...INITIAL_STATE,
    };
  }

  getActions = () => {
    return this.contratoIsLoading() ? null : (
      <>
        <Row className={genericCardStyles.rootClassName + '-card-actions-row'}>
          <Col
            cols={[12, 12, 6, 6, 6]}
            className={genericCardStyles.rootClassName + '-card-actions-left'}
          >
            <CustomButton
              label={
                this.props.languageValues.cadastroContratoAnaliseOperacional
              }
              theme='pufvYellow'
              onClick={this.toAnaliseOperacional}
              leftIcon={<AssignmentLateRoundedIcon />}
              disabled={this.analiseOperacionalIsDisabled()}
            />
          </Col>
          <Col
            cols={[12, 12, 6, 6, 6]}
            className={genericCardStyles.rootClassName + '-card-actions-right'}
          >
            <CustomButton
              label={this.props.languageValues.cadastroContratoRevisoes}
              theme='pufvYellow'
              onClick={this.toRevisoes}
              rightIcon={<HistoryRoundedIcon />}
              disabled={this.revisoesIsDisabled()}
              counter={this.getRevisoesCounter()}
            />
          </Col>
        </Row>
        <Row className={genericCardStyles.rootClassName + '-card-actions-row'}>
          <Col
            cols={[12, 12, 6, 6, 6]}
            className={genericCardStyles.rootClassName + '-card-actions-left'}
          >
            <CustomButton
              label={
                this.props.languageValues.cadastroContratoDownloadValidacao
              }
              theme='pufvYellow'
              onClick={this.toDownloadValidacao}
              leftIcon={<CloudDownloadIcon />}
              disabled={this.downloadValidacaoIsDisabled()}
            />
          </Col>
          <Col
            cols={[12, 12, 6, 6, 6]}
            className={genericCardStyles.rootClassName + '-card-actions-right'}
          >
            <CustomButton
              label={this.getGerarLabel()}
              theme='pufvYellow'
              onClick={this.toGerar}
              rightIcon={<DoneIcon />}
              disabled={this.gerarIsDisabled()}
            />
          </Col>
        </Row>
      </>
    );
  };

  getVersaoId = () => {
    switch (this.props.contratosEntePrivado.contratoEditing.versaoContrato) {
      case CONTRATO_VERSAO_ADITIVO:
        return this.props.contratosEntePrivado.contratoEditing.idAditivo;
      case CONTRATO_VERSAO_DISTRATO:
        return this.props.contratosEntePrivado.contratoEditing.idDistrato;
      case CONTRATO_VERSAO_CONTRATO:
      default:
        return this.props.contratosEntePrivado.contratoEditing.idContrato;
    }
  };

  changeSendingStatus = (status) => {
    return new Promise((resolve) => {
      if (this.state.sending !== status) {
        this.setState(
          {
            sending: status,
          },
          () => {
            resolve();
            if (this.state.analiseOperacionalModalKey)
              this.props.changeModalProps(
                this.state.analiseOperacionalModalKey,
                {
                  loading: this.state.sending,
                }
              );
          }
        );
      } else {
        resolve();
      }
    });
  };

  toSubmitToAnaliseOperacional = (text) => {
    this.changeSendingStatus(true).then(() => {
      this.props.contratoEntePrivadoSendAnaliseOperacional(
        {
          idContrato: this.getVersaoId(),
          versaoContrato:
            this.props.contratosEntePrivado.contratoEditing.versaoContrato,
          justificativa: text,
        },
        () => {
          SnackbarUtils.enqueueSnackbar({
            message: this.props.languageValues.successSendingAnaliseOperacional,
            options: {
              variant: 'success',
            },
          });
          this.props.closeModal(this.state.analiseOperacionalModalKey);
          this.changeSendingStatus(false).then(() => {
            this.setState({
              analiseOperacionalModalKey: null,
            });
          });
        },
        (error) => {
          SnackbarUtils.enqueueSnackbar({
            message:
              error.response.statusText ||
              this.props.languageValues.errorSendingAnaliseOperacional,
            options: {
              variant: 'error',
            },
          });
          this.changeSendingStatus(false);
        }
      );
    });
  };

  toAnaliseOperacional = () => {
    const analiseOperacionalModalKey = this.props.openModal(
      AnaliseOperacionalModal,
      {
        loading: this.state.sending,
        title: this.props.languageValues.cadastroContratoEnviarParaAnalise,
        description:
          this.props.languageValues.cadastroContratoEnviarParaAnaliseSLA,
        descriptionLabel:
          this.props.languageValues
            .cadastroContratoAnaliseOperacionalJustificativa,
        submitCallback: (text) => this.toSubmitToAnaliseOperacional(text),
      }
    ).payload.key;

    this.setState({
      analiseOperacionalModalKey: analiseOperacionalModalKey,
    });
  };

  analiseOperacionalIsDisabled = () => {
    return (
      this.state.sending ||
      !this.props.contratosEntePrivado.contratoEditing.ativo ||
      this.props.loading ||
      !this.props.auth.userPermissions.contratos.entePrivado.edit ||
      this.props.contratosEntePrivado.contratoEditing.flgStatus === -1 ||
      this.props.contratosEntePrivado.contratoEditing.flgStatus !==
        CONTRATO_STATUS_EM_EDICAO
    );
  };

  toRevisoes = () => {
    this.props.openModal(HistoricoAnaliseOperacionalModal, {
      utils: this.props.utils,
      historico:
        this.props.contratosEntePrivado.contratoEditing
          .historicoAnaliseOperacional,
    });
  };

  revisoesIsDisabled = () => {
    return (
      this.state.sending ||
      this.props.loading ||
      this.props.contratosEntePrivado.contratoEditing
        .loadingHistoricoAnaliseOperacional ||
      (this.getRevisoesCounter() ? false : true)
    );
  };

  getRevisoesCounter = () => {
    const counter = this.props.contratosEntePrivado.contratoEditing
      .historicoAnaliseOperacional
      ? this.props.contratosEntePrivado.contratoEditing
          .historicoAnaliseOperacional.length
      : 0;
    return !this.props.loading && counter > 0 ? counter : null;
  };

  getFileName = () => {
    let fileName = '';
    switch (this.props.contratosEntePrivado.contratoEditing.versaoContrato) {
      case CONTRATO_VERSAO_ADITIVO:
        fileName = CONTRATO_VERSAO_ADITIVO_NAME;
        break;
      case CONTRATO_VERSAO_DISTRATO:
        fileName = CONTRATO_VERSAO_DISTRATO_NAME;
        break;
      case CONTRATO_VERSAO_CONTRATO:
      default:
        fileName = CONTRATO_VERSAO_CONTRATO_NAME;
        break;
    }
    return fileName + '-rascunho-data-' + moment().format('DD-MM');
  };

  closeDownloadModal = () => {
    this.props.closeModal(this.state.downloadValidacaoModalKey);
    this.setState({
      downloadValidacaoModalKey: null,
    });
  };

  onDownloadProgress = (event) => {
    const percent = (event.loaded * 1) / event.total;
    if (this.state.downloadValidacaoModalKey) {
      this.props.changeModalProps(this.state.downloadValidacaoModalKey, {
        percent: percent,
      });
    }
  };

  onDownloadSuccess = (resp) => {
    const blob = new Blob([resp.data], {
      type: 'application/pdf',
    });
    let link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = this.getFileName();
    link.class = 'hidden-button';
    document.body.appendChild(link);
    link.click();
    link.remove();

    this.closeDownloadModal();
    SnackbarUtils.enqueueSnackbar({
      message: this.props.languageValues.successDownloadDocumentoValidacao,
      options: {
        variant: 'success',
      },
    });
  };

  onDownloadError = (error) => {
    this.closeDownloadModal();
    SnackbarUtils.enqueueSnackbar({
      message:
        error.response.statusText ||
        this.props.languageValues.errorDownloadDocumentoValidacao,
      options: {
        variant: 'error',
      },
    });
  };

  toDownloadValidacao = () => {
    const downloadValidacaoModalKey = this.props.openModal(ProgressModal, {
      title:
        this.props.languageValues.cadastroContratoArquivosDownloadingValidacao,
      percent: 0,
    }).payload.key;

    this.setState(
      {
        downloadValidacaoModalKey,
      },
      () => {
        this.props.downloadValidacaoContrato(
          this.getVersaoId(),
          this.props.contratosEntePrivado.contratoEditing.versaoContrato,
          this.onDownloadProgress,
          (resp) => this.onDownloadSuccess(resp),
          this.onDownloadError
        );
      }
    );
  };

  downloadValidacaoIsDisabled = () => {
    return (
      this.state.sending ||
      !this.props.contratosEntePrivado.contratoEditing.ativo ||
      this.props.loading ||
      !this.props.auth.userPermissions.contratos.entePrivado.edit ||
      this.props.contratosEntePrivado.contratoEditing.flgStatus === -1 ||
      this.props.contratosEntePrivado.contratoEditing.flgStatus !==
        CONTRATO_STATUS_EM_EDICAO
    );
  };

  getGerarMessageSuccess = () => {
    switch (this.props.contratosEntePrivado.contratoEditing.versaoContrato) {
      case CONTRATO_VERSAO_ADITIVO:
        return this.props.languageValues.successGerarAditivo;
      case CONTRATO_VERSAO_DISTRATO:
        return this.props.languageValues.successGerarDistrato;
      case CONTRATO_VERSAO_CONTRATO:
      default:
        return this.props.languageValues.successGerarContrato;
    }
  };

  getGerarMessageError = () => {
    switch (this.props.contratosEntePrivado.contratoEditing.versaoContrato) {
      case CONTRATO_VERSAO_ADITIVO:
        return this.props.languageValues.errorGerarAditivo;
      case CONTRATO_VERSAO_DISTRATO:
        return this.props.languageValues.errorGerarDistrato;
      case CONTRATO_VERSAO_CONTRATO:
      default:
        return this.props.languageValues.errorGerarContrato;
    }
  };

  toGerar = () => {
    this.changeSendingStatus(true).then(() => {
      this.props.gerarContratoNaoAssinado(
        this.getVersaoId(),
        this.props.contratosEntePrivado.contratoEditing.versaoContrato,
        this.props.utils.getTipoNumberByProps(),
        () => {
          this.changeSendingStatus(false).then(() => {
            SnackbarUtils.enqueueSnackbar({
              message: this.getGerarMessageSuccess(),
              options: {
                variant: 'success',
              },
            });
            this.props.history.push(
              contratoEditRoute.getURLWithParams(
                getContratoTipoByRouteParams(this.props.match.params),
                this.props.contratosEntePrivado.contratoEditing.idContrato,
                CONTRATO_EDIT_ETAPA_ARQUIVOS
              )
            );
          });
        },
        (error) => {
          this.changeSendingStatus(false).then(() => {
            SnackbarUtils.enqueueSnackbar({
              message: error.response.statusText || this.getGerarMessageError(),
              options: {
                variant: 'error',
              },
            });
          });
        }
      );
    });
  };

  gerarIsDisabled = () => {
    return (
      this.state.sending ||
      !this.props.contratosEntePrivado.contratoEditing.ativo ||
      this.props.loading ||
      !this.props.auth.userPermissions.contratos.entePrivado.edit ||
      this.props.contratosEntePrivado.contratoEditing.flgStatus === -1 ||
      this.props.contratosEntePrivado.contratoEditing.flgStatus !==
        CONTRATO_STATUS_EM_EDICAO
    );
  };

  getGerarLabel = () => {
    switch (this.props.contratosEntePrivado.contratoEditing.versaoContrato) {
      case CONTRATO_VERSAO_ADITIVO:
        return this.props.languageValues.cadastroContratoGerarAditivo;
      case CONTRATO_VERSAO_DISTRATO:
        return this.props.languageValues.cadastroContratoGerarDistrato;
      case CONTRATO_VERSAO_CONTRATO:
      default:
        return this.props.languageValues.cadastroContratoGerarContrato;
    }
  };

  getTitle = () => {
    switch (this.props.contratosEntePrivado.contratoEditing.versaoContrato) {
      case CONTRATO_VERSAO_ADITIVO:
        return this.props.languageValues.cadastroContratoValidacaoAditivo;
      case CONTRATO_VERSAO_DISTRATO:
        return this.props.languageValues.cadastroContratoValidacaoDistrato;
      case CONTRATO_VERSAO_CONTRATO:
      default:
        return this.props.languageValues.cadastroContratoValidacaoContrato;
    }
  };

  getPreloaderMessage = () => {
    switch (this.props.contratosEntePrivado.contratoEditing.versaoContrato) {
      case CONTRATO_VERSAO_ADITIVO:
        return this.props.languageValues.loadingAditivo;
      case CONTRATO_VERSAO_DISTRATO:
        return this.props.languageValues.loadingDistrato;
      case CONTRATO_VERSAO_CONTRATO:
      default:
        return this.props.languageValues.loadingContrato;
    }
  };

  getGenericCardScreenProps = () => {
    return {
      GenericCardProps: {
        className: rootClassName,
        title: (
          <CardTitle onClick={this.openStepsMenu}>{this.getTitle()}</CardTitle>
        ),
        actions: this.getActions(),
        CardContentProps: {
          className: rootClassName + '-card-content',
        },
        sending: this.state.sending || this.contratoIsLoading(),
      },
    };
  };

  contratoIsLoading = () => {
    return (
      this.props.loading ||
      this.props.contratosEntePrivado.loadingHtmlContrato ||
      this.props.contratosEntePrivado.loadingHistoricoAnaliseOperacional
    );
  };

  render() {
    return (
      <GenericCardScreen {...this.getGenericCardScreenProps()}>
        {this.contratoIsLoading() ? (
          <Row>
            <Col cols={[12, 12, 12, 12, 12]}>{this.getPreloaderMessage()}</Col>
          </Row>
        ) : (
          <Row>
            <Col cols={[12, 12, 12, 12, 12]}>
              <div
                className={rootClassName + '-html'}
                dangerouslySetInnerHTML={{
                  __html:
                    this.props.contratosEntePrivado.contratoEditing
                      .htmlContrato,
                }}
              />
            </Col>
          </Row>
        )}
      </GenericCardScreen>
    );
  }
}

Validacao.propTypes = {
  utils: PropTypes.object.isRequired,
  loading: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
  contratos: state.contratos,
  contratosEntePrivado: state.contratosEntePrivado,
  auth: state.auth,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      openModal,
      closeModal,
      changeModalProps,
      contratoEntePrivadoSendAnaliseOperacional,
      downloadValidacaoContrato,
      gerarContratoNaoAssinado,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Validacao));
